import React from "react"
import Grid from "@mui/material/Grid"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendarCirclePlus, faPenToSquare } from "@fortawesome/pro-solid-svg-icons"
import { Typography } from "@mui/material"
import { faArrowRight } from "@fortawesome/free-solid-svg-icons"
import { CheckButtonProps } from "../interfaces/calendarDialog.interface"
import { StyledBoxLink } from "../style/CalendarDialog.styled"
import {
  StyledBox,
  StyledFontAwesomeIcon
} from "pages/vehicleregistry/pages/checks/InspectionsHistoryTable.styled"
import { VehicleCheckStatus } from "helpers/Checks/ChecksStatusColor"
import { t } from "i18next"
import theme from "css/theme/light"
import { fontAwesomeOldXlStyle } from "components/icons/fontAwesomeStyles"

export const InspectionButtons = ({ event, openSidebar, handleClose }: CheckButtonProps) => {
  const status = event?.status

  return (
    <>
      {status === VehicleCheckStatus.Booked ? (
      <StyledBox >
        <StyledBoxLink
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          onClick={() => {
            openSidebar(event)
            handleClose()
          }}
        >
          <Grid display="flex" gap={2}>
              <FontAwesomeIcon style={fontAwesomeOldXlStyle} color="grey" icon={faPenToSquare} />
              <Typography variant="h5" color={(theme.palette as any).primary[700]}>
                {t("global.change_booking", "Change booking")}
              </Typography>
          </Grid>
          <StyledFontAwesomeIcon style={fontAwesomeOldXlStyle} icon={faArrowRight} />
        </StyledBoxLink>
      </StyledBox>
      ) : status === VehicleCheckStatus.Passed || status === VehicleCheckStatus.Failed || status === VehicleCheckStatus.Waiting ? null : (
        <StyledBox display="flex" justifyContent="space-between" alignItems="center">
          <StyledBoxLink
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            onClick={() => {
              openSidebar(event)
              handleClose()
            }}>
              <Grid display="flex" gap={2}>
                <FontAwesomeIcon style={fontAwesomeOldXlStyle} color="grey" icon={faCalendarCirclePlus} />
                <Typography variant="h5" color={(theme.palette as any).primary[700]}>
                  {t("global.book", "Book")}
                </Typography>
              </Grid>
            <StyledFontAwesomeIcon style={fontAwesomeOldXlStyle} icon={faArrowRight} />
          </StyledBoxLink>
        </StyledBox>
      )}
    </>
  )
}

export const ServiceButtons = ({ event, handleClose, openSidebar }: CheckButtonProps) => {
  const status = event?.status

  return status === VehicleCheckStatus.Upcoming || status === VehicleCheckStatus.Late ? (
    <StyledBoxLink
      onClick={() => {
        openSidebar(event)
        handleClose()
      }}>
      <StyledBox display="flex" justifyContent="space-between" gap={2} alignItems={"center"}>
        <Grid container gap={2}>
          <FontAwesomeIcon style={fontAwesomeOldXlStyle} color="grey" icon={faPenToSquare} />
          <Typography variant="h5" color={(theme.palette as any).primary[700]}>
            {t("global.approve", "Approve")}
          </Typography>
        </Grid>
        <StyledFontAwesomeIcon style={fontAwesomeOldXlStyle} icon={faArrowRight} />
      </StyledBox>
    </StyledBoxLink>
  ) : (
    <></>
  )
}
